export class tTicket_Session {
    public constructor(init?: Partial<tTicket_Session>) {Object.assign(this, init);}
    // Key
    ticket_session_id: string;
    ticket_id: string;
    // [Write(false)]
    entry_datetime: Date;
    session_id: string;
    docket_number: string;
    ticket_number: string;
    defendant_first_name: string;
    defendant_last_name: string;
    ticket_state_code: string;
    ticket_status_code: string;
    ticket_amount: number;
    ticket_paid: number;
    ticket_balance: number;
    offense_datetime: Date;
    judge_code: string;
    judge_name: string;
    violation_code: string;
    violation_code_description: string;
    violation_location: string;
    plea_code: string;
    plea_name: string;
    plea_date: Date;
    disposition_code: string;
    disposition_name: string;
    disposition_date: Date;
    payment_due_date: Date;
    license_number: string;
    license_number_formatted: string;
    license_state: string;
    ticket_type: string;
    calendar_datetime: Date;
    calendar_code: string;
    calendar_code_name: string;
    is_must_appear: boolean;
    selected_to_pay: boolean;
    is_scoffed: boolean;
    comment: string;
    plate_number: string;
    plate_state: string;
    ticket_status_name: string;
    ticket_state_name: string;
    close_date: Date;
    violation_code_original: string;
    violation_code_description_original: string;
    receipt_date: Date;
    applied_amount: number;
    receipt_number: string;
    payment_amount: number;
    in_collection: boolean;
    charge_schedule_id: string;
    attorney_name: string;
    related_ticket_count: number;
    suspend_payment_due_date: boolean;
    grouping: string;
    grouping_name: string;
    grouping_description: string;
    pbm_id: string;
    offer_rejected_accepted: string;
    ticket_amount_original: number;
    offer_made_date: Date;
    pb_eligible: boolean;
    folder_number: string;
    statement_number: string;
    case_id: string;
    defendant_id: string;
    plate_id: string;
    case_number: string;
    case_sort: number;
    ticket_type_sort_order: number;
    is_primary: boolean;
    is_folder_defendant: boolean;
    account_number: string;
    defendant_company: string;
    default_judgment_id: string;
    collection_payment_plan: boolean;
    minimum_payment_plan_amount: number;
    pin: string;
    adhoc_payment_plan: boolean;
    collection_ticket_event_type_status: string;
    speed_clocked: number;
    speed_zone: number;
}

